import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ThreadPermissionsClient, AddThreadUserDto, UpdatePermissionDto } from '../api/api-client';

const threadPermissionsClient = new ThreadPermissionsClient();

export function useThreadUsers(threadId: number) {
  return useQuery({
    queryKey: ['threadUsers', threadId],
    queryFn: () => threadPermissionsClient.getThreadUsers(threadId),
    enabled: !!threadId
  });
}

export function useAddUserToThread() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ threadId, addMemberDto }: { threadId: number; addMemberDto: AddThreadUserDto }) => 
      threadPermissionsClient.addUserToThread(threadId, addMemberDto),
    onSuccess: (_, { threadId }) => {
      queryClient.invalidateQueries({ queryKey: ['threadUsers', threadId] });
    }
  });
}

export function useUpdateUserPermission() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ threadId, userId, updateDto }: { threadId: number; userId: number; updateDto: UpdatePermissionDto }) => 
      threadPermissionsClient.updateUserPermission(threadId, userId, updateDto),
    onSuccess: (_, { threadId }) => {
      queryClient.invalidateQueries({ queryKey: ['threadUsers', threadId] });
    }
  });
}

export function useRemoveUserFromThread() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ threadId, userId }: { threadId: number; userId: number }) => 
      threadPermissionsClient.removeUserFromThread(threadId, userId),
    onSuccess: (_, { threadId }) => {
      queryClient.invalidateQueries({ queryKey: ['threadUsers', threadId] });
    }
  });
}